<template>
  <div>
    <div class="d-flex">
      <h4 class="font-weight-medium font-16" v-text="DESCRICAO_CATEGORIA" />
      <DetalhamentoCategoriaDialog :detalhamento_categoria="detalhamento_categoria">
        <template #prepend-card-text>
          <h4 class="mt-2 font-15 font-weight-medium">{{DESCRICAO_CATEGORIA}}</h4>
        </template>
      </DetalhamentoCategoriaDialog>
    </div>

    <table style="width: 100%;border-collapse: collapse;">
      <template v-for="(linha, index) in linhas">
        <Linha
          :linha="linha"
          :dados="detalhamento_categoria"
          :key="index"
          :maximoDeColunas="maximoDeColunas"
          class_column="pb-2px"
        >
          <template #coluna.ressuprimento_em_dias="{coluna}">
            <Ressuprimento
              :coluna="coluna"
              :categoria="categoria_selecionada"
              :detalhamento_categoria="detalhamento_categoria"
              @novo-ressuprimento_em_dias="detalhamento_categoria.ressuprimento_em_dias = $event"
            />
          </template>

          <template #coluna.lote_minimo="{coluna}">
            <LoteMinimo
              :coluna="coluna"
              :categoria="categoria_selecionada"
              :detalhamento_categoria="detalhamento_categoria"
              @novo-lote-minimo="detalhamento_categoria.lote_minimo = $event"
            />
          </template>

          <template #coluna.valor.estoque_peso="{valor}">
            <div class="d-flex align-center">
              {{ Helpers.formatarValor(valor) }}

              <EstoquePorLojaDialog :parametros="{grupo: grupo_compra, idcategoria: categoria_selecionada.idcategoria}">
                <template #topo-tabela>
                  <p class="font-15">
                    <span class="font-weight-medium pr-1">Categoria: </span>
                    {{DESCRICAO_CATEGORIA}}
                  </p>
                </template>
              </EstoquePorLojaDialog>
            </div>
          </template>

          <template #coluna.cobertura_manual_categoria>
            <CoberturaManual
              :detalhamento_categoria="detalhamento_categoria"
              @nova-cobertura-manual="detalhamento_categoria.cobertura_manual_categoria = $event"
            />
          </template>

          <template #coluna.previsao_gatilho>
            <PrevisaoGatilho
              :detalhamento_categoria="detalhamento_categoria"
              @novo-previsao-gatilho="detalhamento_categoria.previsao_gatilho = $event"
            />
          </template>

         <template #coluna.estoque_transito_peso="{coluna}">
            <p class="ma-0 font-weight-medium">
              {{coluna.texto}}
              <v-icon small color="#D60E2B">mdi-truck</v-icon>
            </p>

            <div class="d-flex align-center">
              <p class="ma-0 mt-n1" style="color: #D60E2B">{{Helpers.formatarValor(detalhamento_categoria[coluna.valor])}}</p>

              <PedidosPendente
                v-if="detalhamento_categoria[coluna.valor] > 0"
                class="mt-n1"
                :filtros="{grupo: grupo_compra, idcategoria: categoria_selecionada.idcategoria}"
              >
                <template #topo-tabela>
                  <p class="font-15">
                    <span class="font-weight-medium pr-1">Categoria: </span>
                    {{DESCRICAO_CATEGORIA}}
                  </p>
                </template>
              </PedidosPendente>
            </div>
          </template>

          <template #coluna.valor.status_categoria="{valor}">
            <Legenda titulo="Status da categoria" :legenda="Helpers.primeiraLetraMaiuscula(valor)">
              <div class="w-90 text-truncate">{{Helpers.primeiraLetraMaiuscula(valor)}}</div>
            </Legenda>
          </template>

          <template #coluna.valor.nivel_estoque="{valor}">
            <NivelEstoqueProgressCircular
              :tamanho="58"
              :largura="8"
              :valor="valor"
              :status-produto="detalhamento_categoria.status_categoria"
            />
          </template>

          <template #ultima-compra>
            <div class="d-flex">
              <span>Última Compra</span>

              <UltimasCompras
                :filtros="{grupo: grupo_compra, idcategoria: categoria_selecionada.idcategoria}"
                @update:desconsiderar-pedido-em-transito="getDetalhesCategoria"
              >
                <template #topo-tabela.prepend>
                  <p class="font-15 mr-5">
                    <span class="font-weight-medium pr-1">Categoria: </span>
                    {{DESCRICAO_CATEGORIA}}
                  </p>
                </template>
              </UltimasCompras>
            </div>
          </template>

         <template #media-venda-ultimos-meses>
            <div class="d-flex">
              <span>Média de venda nos últimos meses</span>

              <VendasUltimosMeses :filtros="{grupo: grupo_compra, idcategoria: categoria_selecionada.idcategoria}">
                <template #topo-corpo>
                  <p class="font-15 pt-3 pl-5">
                    <span class="font-weight-medium pr-1">Categoria: </span>
                    {{DESCRICAO_CATEGORIA}}
                  </p>
                </template>
              </VendasUltimosMeses>
            </div>
          </template>

          <template #coluna.valor.ordem_compra>
            {{ ultima_compra.ordem_compra || '-' }}
          </template>

          <template #coluna.valor.total_compra>
            {{ Helpers.formatarValor(ultima_compra.total_compra || 0) }}
          </template>

          <template #coluna.valor.qtde>
            {{ Helpers.formatarValor(ultima_compra.qtde || 0) }}
          </template>

          <template #coluna.valor.data_solicitacao>
            {{ ultima_compra.data_solicitacao || 0 }}
          </template>

          <template #coluna.valor.data_previsao>
            {{ ultima_compra.data_previsao || 0 }}
          </template>

          <template #coluna.valor.data_entrega>
            {{ ultima_compra.data_entrega || 0 }}
          </template>

          <template #coluna.valor.media_trimestre>
            {{ Helpers.formatarValor(media_vendas.media_trimestre || 0) }}
          </template>

          <template #coluna.valor.media_semestre>
            {{ Helpers.formatarValor(media_vendas.media_semestre || 0) }}
          </template>

          <template #coluna.valor.media_ano>
            {{ Helpers.formatarValor(media_vendas.media_ano || 0) }}
          </template>

        </Linha>
      </template>
    </table>
  </div>
</template>

<script>
import { categoria_selecionada } from "../../Helpers/CategoriaSelecionado.js";
import { buscarDetalhesCategoria } from '@/api/compras/MateriaPrima';
import Linha from '@/components/produto/detalhes/LinhaTabelaDetalhesProdutos.vue';
import EstoquePorLojaDialog from "./EstoquePorFilial.vue";
import NivelEstoqueProgressCircular from '@/components/produto/detalhes/NivelEstoqueProgressCircular.vue';
import Ressuprimento from './Ressuprimento.vue';
import LoteMinimo from "./LoteMinimo.vue";
import CoberturaManual from "./CoberturaManual.vue";
import PrevisaoGatilho from "./PrevisaoGatilho.vue";
import PedidosPendente from "./PedidosPendente.vue";
import UltimasCompras from "./UltimasCompras.vue";
import VendasUltimosMeses from './VendasUltimosMeses.vue';
import DetalhamentoCategoriaDialog from './DetalhamentoCategoriaDialog.vue';
import { logout } from "@/helpers";
import { mapGetters } from 'vuex';
import Legenda from "@/components/produto/detalhes/Legenda";

export default {
  mixins: [categoria_selecionada],
  components: {
    Legenda,
    Linha,
    Ressuprimento,
    LoteMinimo,
    EstoquePorLojaDialog,
    CoberturaManual,
    PrevisaoGatilho,
    PedidosPendente,
    NivelEstoqueProgressCircular,
    UltimasCompras,
    VendasUltimosMeses,
    DetalhamentoCategoriaDialog
},
  props: {
    count_atualizar_detalhes_categoria: Number,
  },
  data: () => ({
    linhas: [
      {
        colunas: [
          {texto: 'Prioridade', valor: 'peso_compras'},
          {texto: 'Preço de Compra', valor: 'preco_compra', formatarDinheiro: true},
          {texto: 'Ressuprimento', valor: 'ressuprimento_em_dias', formatar: true, append: 'dias'},
          {texto: 'Lote Mínimo', valor: 'lote_minimo', formatar: true},
          {texto: 'Embalagem', valor: 'idunidade_medida'},
          {texto: 'Previsão gatilho', valor: 'previsao_gatilho'},
        ]
      },
      {
        divider: true,
        titulo: 'Estoques e coberturas',
      },
      {
        colunas: [
          {texto: 'Nível Estoque', valor: 'nivel_estoque', rowspan: 2},
          {texto: 'Saldo de Estoque', valor: 'estoque_peso', formatar: true},
          {texto: 'Estoque Segurança', valor: 'estoque_seguranca', formatar: true},
          {texto: 'Ponto de Pedido', valor: 'ponto_pedido', formatar: true},
          {texto: 'Estoque Máximo', valor: 'estoque_maximo', formatar: true},
          {texto: 'Cobertura Manual', valor: 'cobertura_manual_categoria', formatar: true},
        ]
      },
      {
        colunas: [
          {texto: 'Cobertura Instântanea', valor: 'cobertura_instantanea_diaria', formatar: true, append: 'dias'},
          {texto: 'Cobertura Eseg', valor: 'cobertura_esseg_diaria', formatar: true, append: 'dias'},
          {texto: 'Cobertura PP', valor: 'cobertura_pp_diaria', formatar: true, append: 'dias'},
          {texto: 'Cobertura Emax', valor: 'cobertura_emax_diaria', formatar: true, append: 'dias'},
          {texto: 'Giro de Estoque', valor: 'giro_diario', formatar: true},
        ]
      },
      {
        colunas: [
          {texto: 'Status Categoria', valor: 'status_categoria'},
          {texto: 'Fator de Conversão', valor: 'fator_conversao', formatar: true},
          {texto: 'Bloqueado', valor: 'estoque_bloqueado_peso', formatar: true},
          {texto: 'Em Trânsito', valor: 'estoque_transito_peso', formatar: true},
          {texto: 'Avaria', valor: 'estoque_avaria_peso', formatar: true},
          {texto: 'Reservado', valor: 'estoque_reservado_peso', colspan: 2, formatar: true},
        ]
      },
      {
        divider: true,
        titulo: 'Última Compra',
        nome: 'ultima-compra'
      },
      {
        colunas: [
          {texto: 'Pedido', valor: 'ordem_compra'},
          {texto: 'Total item', valor: 'total_compra'},
          {texto: 'Quantidade', valor: 'qtde'},
          {texto: 'Solicitação', valor: 'data_solicitacao'},
          {texto: 'Previsão', valor: 'data_previsao'},
          {texto: 'Entrada', valor: 'data_entrega'}
        ]
      },
      {
        divider: true,
        titulo: 'Média de venda nos últimos meses',
        nome: 'media-venda-ultimos-meses'
      },
      {
        colunas: [
          {texto: '3 meses', valor: 'media_trimestre', formatar: true},
          {texto: '6 meses', valor: 'media_semestre', formatar: true},
          {texto: '12 meses', valor: 'media_ano', formatar: true},
          {texto: 'Projeção de vendas', valor: 'cmm_peso', formatar: true}
        ]
      }
    ],
    maximoDeColunas: 6,
    detalhamento_categoria: {
      unidade_compra: "-",
      ressuprimento_em_dias: "-"
    },
  }),
  computed: {
    ...mapGetters({
      grupo_compra: "usuario/getGrupoCompras",
      filial_compra: "usuario/getFilialCompras",
    }),
    DESCRICAO_CATEGORIA() {
      const {idcategoria, descricao_categoria} = this.categoria_selecionada;
      const decricao_formatada = `${descricao_categoria[0] || ''}`.toUpperCase();
      return `${idcategoria} - ${decricao_formatada.concat(descricao_categoria.substring(1).toLowerCase())}`
    },
    ultima_compra() {
      if (!this.detalhamento_categoria.ultima_compra) return {};
      return this.detalhamento_categoria.ultima_compra;
    },
    media_vendas() {
      if (!this.detalhamento_categoria.media_vendas) return {};
      return this.detalhamento_categoria.media_vendas;
    }
  },
  watch: {
    categoria_selecionada() {
      this.getDetalhesCategoria();
    },
    count_atualizar_detalhes_categoria() {
      this.getDetalhesCategoria();
    }
  },
  mounted() {
    this.getDetalhesCategoria();
  },
  methods: {
    getDetalhesCategoria() {
      const parametros = {
        id_grupo: this.grupo_compra,
        filial: 9999,
        id_categoria: this.categoria_selecionada.idcategoria
      };

      this.$store.dispatch(
        "loading/addRequisicao",
        buscarDetalhesCategoria(parametros)
          .then(this.atualizarDados)
          .catch(logout)
      );
    },
    atualizarDados(detalhamento) {
      this.detalhamento_categoria = detalhamento;
    }
  },
}
</script>

<style scoped>
</style>
